import StyleList from './style_list_config';
import moduleCss from '../widgets/basic_module/style';

//生成一个module
//默认样式是每个挂件自己的默认样式 加上 module的默认样式
//这里的默认data，必须要深拷贝，
class OneModule {
  constructor({ pid, name, widgets_id, rowType, data = {} }) {
    this.name = name;
    this.pid = pid;
    this.widgets_id = widgets_id;
    // this.data = data;
    this.rowType = rowType; //父容器的类型
    this.isShow = true; //module隐藏或显示
    // JSON.parse(JSON.stringify(Object.assign({}, moduleCss, StyleList[name])))
    let styleData = JSON.parse(JSON.stringify(Object.assign({}, moduleCss, StyleList[name])))
    if (JSON.stringify(data) == '{}') {
      this.data = styleData
    } else {
      let ver = (typeof data.version == 'undefined') ? 0 : data.version
      let sver = (typeof StyleList[name].version == 'undefined') ? 0 : StyleList[name].version
      if (ver != sver) {        
        this.setInitFields(StyleList[name], data)
        console.log('update_filed_name', name)
        console.log('update_filed_data', data)
      }
      this.data = data
    }
  }
  setInitFields(list, obj) {
    Object.keys(list).forEach(key => {
      if (typeof obj[key] == 'undefined') {
        obj[key] = list[key]
      } else if (typeof obj[key] == 'object' && obj[key] !== null) {
        this.setInitFields(list[key], obj[key])
      }
    })
  }
}

export default OneModule;



// WEBPACK FOOTER //
// ./src/base/one_module.js